import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";
import { StyledCashFlowWrapper } from "../styledCashFlow";
import CashFlowBalancesHistoryContainer from "./balanceHistory/CashFlowBalancesHistoryContainer";

const DEFAULT_TAB = "balances-history";

const CashFlowTabsContainer = ({ match }) => {
  const { t } = useTranslation("cashFlow");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "balances-history": {
        return 0;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <StyledContentWrapper>
      <StyledCashFlowWrapper>
        <StyledTabsHead
          className="tab-head"
          orientation="horizontal"
        >
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="horizontal"
            className="tab-head-buttons"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={t("tabs.balancesHistory")} value="balances-history" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={tabValue}
            index={0}
          >
            <CashFlowBalancesHistoryContainer match={match} />
          </TabPanel>
        </StyledTabsBody>
      </StyledCashFlowWrapper>
    </StyledContentWrapper>
  );
};

export default CashFlowTabsContainer;